import { forwardRef, type Ref, type SVGProps } from "react";

function SvgTriangleExclamation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 17" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M6.708 2.483C7.99.41 11.007.41 12.289 2.483l5.572 9.01c1.352 2.185-.22 5.006-2.79 5.006H3.926c-2.57 0-4.142-2.82-2.79-5.007zM9.5 6c.362 0 .656.294.656.657v3.5a.656.656 0 1 1-1.312 0v-3.5c0-.363.294-.657.656-.657m.875 6.563a.875.875 0 1 1-1.75 0 .875.875 0 0 1 1.75 0"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgTriangleExclamation);
export default ForwardRef;
